import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["data-test"]
const _hoisted_2 = ["data-test"]
const _hoisted_3 = {
  key: 1,
  class: "modal-title tw-text-core-primary-10 headlines--headline-06",
  "data-test": "modal-title"
}

import SVGIcon from 'frontcore/views/icons/SVGIcon.vue'

type Emits = (e: 'close') => void

export default /*@__PURE__*/_defineComponent({
  __name: 'ModalHeader',
  props: {
  iconName: {
    type: String,
    required: false,
  },
  title: {
    type: String,
    required: false,
  },
  dataTest: {
    type: String,
    default: '',
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {



const emit = __emit


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "coremodal-header tw-flex tw-justify-between tw-items-center",
    "data-test": __props.dataTest
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'tw-flex tw-grow',
        'tw-items-center',
      ]),
      "data-test": `${__props.dataTest}-title`
    }, [
      (__props.iconName)
        ? (_openBlock(), _createBlock(SVGIcon, {
            key: 0,
            class: "coremodal-header__icon tw-mr-2",
            iconName: __props.iconName,
            "data-test": "icon-title",
            colorClass: "tw-fill-core-primary-50"
          }, null, 8, ["iconName"]))
        : _createCommentVNode("", true),
      (__props.title)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.title), 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    _createElementVNode("div", {
      class: "cursor-pointer",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('close')), ["stop"]))
    }, [
      _createVNode(SVGIcon, {
        iconName: "Close",
        "data-test": "icon-close",
        colorClass: "tw-fill-core-neutral-cold-20"
      })
    ])
  ], 8, _hoisted_1))
}
}

})